"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _dist = require("@low6dev/react-utils/dist");

var _polished = require("polished");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n  justify-content: space-between;\n  height: 3rem;\n  padding: 0 1rem;\n\n  @media (min-width: ", ") {\n    padding: 0 1.25rem;\n  }\n"])), function (props) {
  return props.theme.screenWidthMd;
});

var StyledCancelButton = _styledComponents.default.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n"])));

var StyledLeftEnd = _styledComponents.default.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex: 0 0 36px;\n  width: 36px;\n  height: 3rem;\n"])));

var StyledLoginButton = _styledComponents.default.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  border: 0;\n  border-radius: 1rem;\n  height: 2rem;\n  padding: 0 0.75rem;\n  font-size: 0.75rem;\n  white-space: nowrap;\n  font-weight: ", ";\n  background: ", ";\n  color: ", ";\n"])), function (p) {
  return p.theme.fontWeightBold;
}, function (p) {
  return p.theme.colorPrimary;
}, function (p) {
  return p.theme.colorPrimaryText;
});

var StyledIconButton = _styledComponents.default.button(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translateY(-50%);\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  width: 36px;\n  font-size: 26px;\n  height: 2rem;\n  color: ", ";\n\n  &:disabled {\n    color: ", ";\n  }\n"])), function (props) {
  return props.theme.colorLabel;
}, function (p) {
  return (0, _polished.rgba)(p.theme.colorPrimaryText, 0.25);
});

var StyledCancelIcon = (0, _styledComponents.default)(_fiverReactUiComponents.MatIcon)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: 30px;\n  color: ", ";\n"])), function (p) {
  return p.theme.colorLabel;
});

var StyledLockedStatus = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  text-align: center;\n  text-transform: capitalize;\n  color: ", ";\n"])), function (p) {
  return p.theme.colorText;
});

var StyledDummyEnd = _styledComponents.default.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  flex: 0 0 30px;\n  width: 30px;\n"])));

var StyledLockIconWrapper = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background: ", ";\n"])), function (p) {
  return p.theme.colorLightGrey;
});

var StyledLockIcon = (0, _styledComponents.default)(_fiverReactUiComponents.MatIcon)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  color: ", ";\n"])), function (p) {
  return p.theme.colorText;
});

var StyledButtons = _styledComponents.default.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n"])));

var StyledText = _styledComponents.default.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n  font-size: 0.65rem;\n  line-height: 1.1075;\n  text-align: center;\n\n  color: ", ";\n\n  @media (min-width: ", ") {\n    padding: 0 2rem;\n  }\n"])), function (p) {
  return p.theme.colorText;
}, function (props) {
  return props.theme.screenWidthMd;
});

var Wrapper = function Wrapper(_ref) {
  var translations = _ref.translations,
      progressTotal = _ref.progressTotal,
      progressCurrent = _ref.progressCurrent,
      onClearButtonClicked = _ref.onClearButtonClicked,
      onHelpButtonClicked = _ref.onHelpButtonClicked,
      onLoginButtonClicked = _ref.onLoginButtonClicked,
      onLogoutButtonClicked = _ref.onLogoutButtonClicked,
      onSignupButtonClicked = _ref.onSignupButtonClicked,
      showLoginButton = _ref.showLoginButton,
      isLoggedIn = _ref.isLoggedIn;

  var _useSelector = (0, _reactRedux.useSelector)(function (s) {
    return s.betbar;
  }),
      activePickem = _useSelector.activePickem,
      activeBet = _useSelector.activeBet;

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, {
    children: !isLoggedIn ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledButtons, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLoginButton, {
          onClick: onLoginButtonClicked,
          children: translations.login
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledText, {
          children: translations.betbartext
        })]
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLeftEnd, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLoginButton, {
          onClick: onLogoutButtonClicked,
          children: translations.logout
        })
      }), !activePickem && /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
        skeletonWidth: "140px",
        skeletonHeight: "24px"
      }), !activeBet && activePickem && (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) !== "APPROVED" && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLockedStatus, {
        children: translations.ended
      }), !activeBet && (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) === "APPROVED" && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.ProgressBar, {
          widthWrapper: "6rem",
          current: progressCurrent,
          total: progressTotal
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledCancelButton, {
          onClick: onClearButtonClicked,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledCancelIcon, {
            children: "cancel"
          })
        })]
      }), !activeBet && (activePickem === null || activePickem === void 0 ? void 0 : activePickem.status) !== "APPROVED" && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledDummyEnd, {}), activeBet && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLockedStatus, {
          children: translations.lockedIn
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLockIconWrapper, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLockIcon, {
            children: "lock"
          })
        })]
      })]
    })
  });
};

var _default = Wrapper;
exports.default = _default;